import { useAuth0 } from "@auth0/auth0-react";
import React, { useState, useEffect, useContext } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Text, Spinner, MenuDivider, GridItem, Box, Input, InputGroup, InputRightElement, IconButton } from "@chakra-ui/react";
import { ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";
import { useNavigate } from 'react-router-dom';
import { Flex, Image } from "@chakra-ui/react";
import { useFeatureFlags } from './FeatureFlags';  // Import your useFeatureFlags hook
import { ThemeProvider, CSSReset, ColorModeProvider, extendTheme } from "@chakra-ui/react";
import { nmaTheme, revedyTheme, theosTheme, hopdocTheme, usmonTheme, memorycareaiTheme } from '../themes';  // Import your themes
import { Button, useColorMode } from '@chakra-ui/react';

import { AppContext } from './AppContext';

const AccountMenu = () => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  //const { featureFlags } = useFeatureFlags();

  if (!isAuthenticated) {
    return (
      (  
      <Menu>
        <MenuButton as={Button} variant="link" fontSize="sm" textDecoration="underline" color="menu_text_primary">
          Get Started <ChevronDownIcon />
        </MenuButton>
        <MenuList>
          <MenuItem isDisabled fontSize="sm" color="black">Login Required</MenuItem>
        </MenuList>
      </Menu>
      )
    );
  }


  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  if (isLoading) {
    return <Spinner />;
  }

  //const displayEmail = featureFlags && featureFlags['email'] ? featureFlags['email'] : user.email;
  const displayEmail = user.email;

  return (
    <Menu>
      <MenuButton as={Button} variant="link"  fontSize="sm" textDecoration="underline" color="menu_text_primary">
        Account<ChevronDownIcon />
      </MenuButton>
      <MenuList>
        <MenuItem isDisabled fontSize="sm" color="black">
          {displayEmail}
        </MenuItem>
        <MenuItem onClick={handleLogout} fontSize="sm" color="black">Log Out</MenuItem>
      </MenuList>
    </Menu>
  ) 
};


const AccountMenuLoggedIn = () => {
  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const { featureFlags } = useFeatureFlags();
  const { accessToken } = useContext(AppContext);
  const navigate = useNavigate();
  const [quickSwitchUsers, setQuickSwitchUsers] = useState([]);
  const [isFetchingUsers, setIsFetchingUsers] = useState(false);

  useEffect(() => {
    const fetchQuickSwitchUsers = async () => {
      if (!accessToken || !featureFlags) return;
      
      const isSuperAdmin = featureFlags['user_role'] === 'superadmin' || featureFlags['original_user_role'] === 'superadmin';
      if (!isSuperAdmin) return;
      
      setIsFetchingUsers(true);
      try {
        const response = await fetch(`${window.env.REACT_APP_REVEDY_API_HOST}/admin/quick_switch_users`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          setQuickSwitchUsers(data.users || []);
        }
      } catch (error) {
        console.error("Failed to fetch quick switch users:", error);
      } finally {
        setIsFetchingUsers(false);
      }
    };

    fetchQuickSwitchUsers();
  }, [accessToken, featureFlags]);

  if (!isAuthenticated) {
    return (
      (  
      <Menu>
        <MenuButton as={Button} variant="link"  fontSize="sm" textDecoration="underline" color="menu_text_primary">
          Get Started<ChevronDownIcon />
        </MenuButton>
        <MenuList>
          <MenuItem isDisabled fontSize="sm" color="black">Login Required</MenuItem>
        </MenuList>
      </Menu>
      )
    );
  }

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  const handleImpersonate = async (targetUserId) => {
    try {
      const response = await fetch(`${window.env.REACT_APP_REVEDY_API_HOST}/start_impersonation`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ impersonated_user_id: targetUserId })
      });
      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Failed to start impersonation:", error);
    }
  };

  const handleStopImpersonating = async () => {
    try {
      const response = await fetch(`${window.env.REACT_APP_REVEDY_API_HOST}/stop_impersonation`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Failed to stop impersonation:", error);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  const displayEmail = featureFlags && featureFlags['email'] ? featureFlags['email'] : user.email;
  const isImpersonating = featureFlags && featureFlags['email'] && featureFlags['email'] !== user.email;

  return (
    <Menu>
      <MenuButton as={Button} variant="link"  fontSize="sm" textDecoration="underline" color="menu_text_primary">
        Account <ChevronDownIcon />
      </MenuButton>
      <MenuList>
        <MenuItem isDisabled fontSize="sm" color="black">
          {displayEmail}
        </MenuItem>
        
        {isImpersonating && (
          <MenuItem onClick={handleStopImpersonating} fontSize="sm" color="red.500" fontWeight="bold">
            Stop Impersonating
          </MenuItem>
        )}

        <MenuItem onClick={handleLogout} fontSize="sm" color="black">Log Out</MenuItem>

        {featureFlags && (featureFlags['user_role'] === 'superadmin' || featureFlags['original_user_role'] === 'superadmin') && (
          <>
            <MenuDivider />
            <MenuItem
              onClick={() => navigate('/super-admin-dashboard')}
              fontSize="sm"
              color="purple.700"
              fontWeight="semibold"
            >
              Super-Admin Dashboard
            </MenuItem>
          </>
        )}

        {featureFlags && (featureFlags['user_role'] === 'superadmin' || featureFlags['original_user_role'] === 'superadmin') && quickSwitchUsers.length > 0 && (
          <>
            <MenuDivider />
            <MenuItem isDisabled fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase">
              Quick Switch (Admins)
            </MenuItem>
            <Box maxHeight="200px" overflowY="auto">
              {quickSwitchUsers.map(u => (
                <MenuItem 
                  key={u.id} 
                  onClick={() => handleImpersonate(u.id)} 
                  fontSize="sm" 
                  color="black"
                >
                  <Flex direction="column">
                    <Text>{u.email}</Text>
                    <Text fontSize="xs" color="gray.500">{u.org_name}</Text>
                  </Flex>
                </MenuItem>
              ))}
            </Box>
          </>
        )}
      </MenuList>
    </Menu>
  ) 
};



const MenuVersionDefault = () => {
  const navigate = useNavigate();

  const handleItemClick = (path) => {
    navigate(path);
  };

  return (
    <GridItem
      bg='header_background'
      borderBottom='1px'
      borderColor='brand.200'
      paddingY={4}
      paddingX={6}
      area={'header'}
    >
      <Flex justifyContent="space-between" alignItems="center" width="100%" height="100%">
        <Image src="/images/revedy_logo.png" alt="Revedy" height={["15px"]} onClick={() => handleItemClick('/home')} />
        <Flex style={{ gap: '20px' }}>
        <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/home')}>
            Home
          </Text>
          <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/note')}>
            Code Notes
          </Text>
          <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/generate')}>
            Create Notes
          </Text>
          <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/chat')}>
            Interactive
          </Text>
          <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/ionmtext')}>
            Code IONM CPT
          </Text>
          <Text fontSize="sm" textDecoration="underline" color="menu_text_primary" cursor="pointer" onClick={() => handleItemClick('/api-docs')}>
            API
          </Text>
          
          <Menu>
      <MenuButton as={Button} variant="link"  fontSize="sm" textDecoration="underline" color="menu_text_primary">
        More <ChevronDownIcon />
      </MenuButton>
      <MenuList>
        <MenuDivider />
        <MenuItem fontSize="sm" color="black" isDisabled>
          Other
        </MenuItem>
        {/* Add Integration Services as a new MenuItem */}
        <MenuItem pl={5} fontSize="sm" color="black" onClick={() => handleItemClick('/analyticsdemo')}>
          Integration Services
        </MenuItem>
        {/* Move the Coming Soon text into a MenuItem */}
        <MenuItem pl={5} fontSize="sm" textDecoration="underline" color="menu_text_secondary" isDisabled>
          More Features Coming Soon
        </MenuItem>
        {/* Existing menu items */}
        <MenuItem pl={5} fontSize="sm" color="black" onClick={() => handleItemClick('/transition')}>
          Care Transitions (beta)
        </MenuItem>
        <MenuItem pl={5} fontSize="sm" color="black" onClick={() => handleItemClick('/denials-queue')}>
          Denials Queue
        </MenuItem>
        <MenuItem pl={5} fontSize="sm" color="black" onClick={() => handleItemClick('/CPT2024')}>
          CPT 2024 changes (beta)
        </MenuItem>
      </MenuList>
    </Menu>
        </Flex>
        <AccountMenu />
      </Flex>
    </GridItem>
  );
};


const defaultMenuStructure = {
  'logo': { 'src': '/images/revedy_logo.png', 'alt': 'Revedy', 'height': '15px', 'path': '/home' },
  'items': [
    { 'Home': '/home' },
    { 'Code Notes': '/note' },
    { 'Create Notes': '/generate' },
    { 'Interactive': '/chat' },
    { 'Code IONM CPT': '/ionmtext' },
    { 'API': '/api-docs' },
    { 'More': {
      'sub': [
        { 'Integration Services': '/analyticsdemo' },
        { 'Care Transitions (beta)': '/transition' },
        { 'Denials Queue': '/denials-queue' },
        { 'CPT 2024 changes (beta)': '/CPT2024' },
        { 'Impact Portfolio': '/impact-portfolio' },
        { 'USN Dashboard': '/usn-dashboard' },
        { 'USN Coding Quality': '/usn-coding-quality' },
        { 'USN Claims': '/usn-claims' },
        { 'NMA Workflow': '/nma-workflow' },
        { 'NMA Claims': '/nma-claims' },
        { 'NMA Appeals': '/nma-appeals' },
        { 'NMA Meta-Analysis': '/nma-meta-analysis' },
        { 'Projects': '/projects' },
        { 'ZinniaX Reconciliation': '/zinniax-reconciliation' },
        { 'NMA Compliance': '/nma-compliance' },
        { 'Coding Search': '/coding-search' }
      ]
    }}
  ]
};




const GlobalSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate('/search', { state: { query: searchQuery.trim() } });
      setSearchQuery('');
    }
  };

  return (
    <form onSubmit={handleSearch} style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
      <InputGroup size="sm" width="200px">
        <Input
          placeholder="Search cases..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          bg="white"
          borderRadius="md"
          borderColor="gray.300"
          _hover={{ borderColor: "gray.400" }}
          _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px #3182ce" }}
        />
        <InputRightElement>
          <IconButton
            aria-label="Search"
            icon={<SearchIcon />}
            size="xs"
            variant="ghost"
            onClick={handleSearch}
          />
        </InputRightElement>
      </InputGroup>
    </form>
  );
};

const HeaderMenus = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { featureFlags } = useFeatureFlags();
  const navigate = useNavigate();

  // Use the menu structure from feature flags if it exists, otherwise use the default
  const menuStructure = featureFlags['menu_structure'] || defaultMenuStructure;

  // Detect local development environment
  const isLocalDevelopment = window.env.REACT_APP_REVEDY_API_HOST && 
    window.env.REACT_APP_REVEDY_API_HOST.includes('local');

  let theme = revedyTheme;
  if (featureFlags && featureFlags['menu_version']) {
    switch (featureFlags['menu_version']) {
      case 'nma': theme = nmaTheme; break;
      case 'usmon': theme = usmonTheme; break;
      case 'memorycareai': theme = memorycareaiTheme; break;
      case 'hopdoc': theme = hopdocTheme; break;
      case 'theos': theme = theosTheme; break;
      default: theme = revedyTheme;
    }
  }

  const renderMenuItem = (item) => {
    const [label, value] = Object.entries(item)[0];

    if (typeof value === 'string') {
      return (
        <Text 
          key={label}
          fontSize="sm" 
          textDecoration="underline" 
          color="menu_text_primary" 
          cursor="pointer" 
          onClick={() => navigate(value)}
        >
          {label}
        </Text>
      );
    }

    if (typeof value === 'object' && value.sub) {
      return (
        <Menu key={label}>
          <MenuButton as={Button} variant="link"  fontSize="sm" textDecoration="underline" color="menu_text_primary">
            {label} <ChevronDownIcon />
          </MenuButton>
          <MenuList>
            <MenuDivider />
            <MenuItem fontSize="sm" color="black" isDisabled>Other</MenuItem>
            {value.sub.map((subItem, index) => {
              const [subLabel, subPath] = Object.entries(subItem)[0];
              return (
                <MenuItem key={index} pl={5} fontSize="sm" color="black" onClick={() => navigate(subPath)}>
                  {subLabel}
                </MenuItem>
              );
            })}
          </MenuList>
        </Menu>
      );
    }

    return null;
  };

  return (
    <ThemeProvider theme={theme}>
      <CSSReset />
      <ColorModeProvider>
        <GridItem
          bg='header_background'
          borderBottom='1px'
          borderColor='brand.200'
          paddingY={4}
          paddingX={6}
          area={'header'}
        >
          <Flex justifyContent="space-between" alignItems="center" width="100%" height="100%">
            {/* Logo and tagline container */}
            <Flex alignItems="center">
              <Image 
                src={menuStructure.logo.src} 
                alt={menuStructure.logo.alt} 
                height={[menuStructure.logo.height]} 
                onClick={() => navigate(menuStructure.logo.path)}
                cursor="pointer"
              />
              <Text 
                ml={3} 
                fontSize="sm" 
                color="menu_text_secondary" 
                fontStyle="italic"
              >
                Revedy - Your AI Agent for RCM
              </Text>
            </Flex>
            <Flex style={{ gap: '20px' }}>
              {menuStructure.items.map((item, index) => renderMenuItem(item, index))}
            </Flex>
            <Flex alignItems="center">
              <GlobalSearch />
              <AccountMenuLoggedIn />
            </Flex>
          </Flex>
        </GridItem>
      </ColorModeProvider>
    </ThemeProvider>
  );
};


export default HeaderMenus;
export { MenuVersionDefault };